import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type ApplyEventRequest = {
  eventId: EventType["id"];
};

export type ApplyEventResponse = unknown;

export const applyEvent = async (body: ApplyEventRequest): Promise<ApplyEventResponse> => {
  const { data } = await axios.post(`/events/${body.eventId}/apply`);

  return data;
};
